export default "__VITE_ASSET__CyPlYVXm__"